import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createPurchaseOrder,
  updatePurchaseOrder,
  submitPurchaseOrder,
  approvePurchaseOrder,
  cancelPurchaseOrder,
  convertPurchaseOrderToBill,
  deletePurchaseOrder,
} from "api/purchaseOrder.api";
import {
  invalidateExpenseSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

const invalidatePOs = (qc) =>
  qc.invalidateQueries({ queryKey: ["purchase-orders"] });

export const useCreatePurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createPurchaseOrder,
    onSuccess: () => invalidatePOs(qc),
  });
};

export const useUpdatePurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...payload }) => updatePurchaseOrder(id, payload),
    onSuccess: () => invalidatePOs(qc),
  });
};

export const useSubmitPurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: submitPurchaseOrder,
    onSuccess: () => invalidatePOs(qc),
  });
};

export const useApprovePurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: approvePurchaseOrder,
    onSuccess: () => invalidatePOs(qc),
  });
};

export const useCancelPurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: cancelPurchaseOrder,
    onSuccess: () => invalidatePOs(qc),
  });
};

export const useConvertPurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => convertPurchaseOrderToBill(id, body),
    onSuccess: () => {
      invalidatePOs(qc);
      invalidateExpenseSide(qc); // a new bill was created
      invalidateVendorSide(qc); // vendor payable changed
    },
  });
};

export const useDeletePurchaseOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deletePurchaseOrder,
    onSuccess: () => invalidatePOs(qc),
  });
};
